var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyPointsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "77px",
    height: "86px",
    viewBox: "0 0 77 86",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 12") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ManPower-Associate-PWA",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AssociatePWA-reward-all",
    transform: "translate(-294.000000, -157.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(20.000000, 152.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(274.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#0C2186",
    points: "24.6734 85.3287 31.4972 85.3287 31.4972 65.7471 24.6734 65.7471"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#466EA5",
    points: "5.0921 85.3287 24.6734 85.3287 24.6734 65.7471 5.0921 65.7471"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-7",
    fill: "#00084B",
    points: "16.4327 70.6419 15.9077 71.3283 15.083 70.2612 14.225 71.2338 13.5653 70.4262 12.7232 71.346 12.7232 65.7471 17.042 65.7471 17.042 71.1978 16.4327 70.6419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5144,81.1506 C57.5144,83.3925 55.6802,85.2267 53.4383,85.2267 L24.6305,85.2267 C22.3886,85.2267 20.5544,83.3925 20.5544,81.1506 L20.5544,15.0345 C20.5544,12.7929 22.3886,10.9587 24.6305,10.9587 L53.4383,10.9587 C55.6802,10.9587 57.5144,12.7929 57.5144,15.0345 L57.5144,81.1506",
    id: "Fill-8",
    fill: "#466EA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3321,11.931 L23.2166,11.931 C21.1067,11.931 19.3805,13.6572 19.3805,15.7674 L19.3805,80.2203 C19.3805,82.3305 21.1067,84.0564 23.2166,84.0564 L50.3321,84.0564 C52.4423,84.0564 54.1685,82.3305 54.1685,80.2203 L54.1685,15.7674 C54.1685,13.6572 52.4423,11.931 50.3321,11.931",
    id: "Fill-9",
    fill: "#8AB2E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2166,11.8992 C21.0836,11.8992 19.3484,13.6344 19.3484,15.7674 L19.3484,80.2203 C19.3484,82.3536 21.0836,84.0888 23.2166,84.0888 L50.3321,84.0888 C52.4654,84.0888 54.2006,82.3536 54.2006,80.2203 L54.2006,15.7674 C54.2006,13.6344 52.4654,11.8992 50.3321,11.8992 L44.2919,11.8992 L43.3712,14.4834 C43.2923,14.6721 43.0589,14.8269 42.8525,14.8269 L30.6965,14.8269 C30.4898,14.8269 30.2564,14.6721 30.1766,14.4816 L29.2568,11.8992 L23.2166,11.8992 Z M22.3703,85.1946 C20.1407,85.1946 18.3263,83.3808 18.3263,81.1506 L18.3263,15.0345 C18.3263,12.8046 20.1407,10.9905 22.3703,10.9905 L51.1784,10.9905 C53.4083,10.9905 55.2224,12.8046 55.2224,15.0345 L55.2224,81.1506 C55.2224,83.3808 53.4083,85.1946 51.1784,85.1946 L22.3703,85.1946 L22.3703,85.1946 Z",
    id: "Fill-10",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6962,14.859 L36.7742,14.859 C36.7745,14.859 41.4458,14.859 42.8525,14.859 C43.0709,14.859 43.3169,14.6955 43.4015,14.4939 L44.3144,11.931 L50.3321,11.931 C52.4423,11.931 54.1685,13.6572 54.1685,15.7674 L54.1685,80.2203 C54.1685,82.3305 52.4423,84.0564 50.3321,84.0564 L23.2166,84.0564 C21.1067,84.0564 19.3805,82.3305 19.3805,80.2203 L19.3805,15.7674 C19.3805,13.6572 21.1067,11.931 23.2166,11.931 L29.2346,11.931 L30.1472,14.4939 C30.2318,14.6955 30.4778,14.859 30.6962,14.859 Z M51.1784,10.9587 L22.3703,10.9587 C20.1287,10.9587 18.2945,12.7929 18.2945,15.0345 L18.2945,81.1506 C18.2945,83.3925 20.1287,85.2267 22.3703,85.2267 L51.1784,85.2267 C53.42,85.2267 55.2545,83.3925 55.2545,81.1506 L55.2545,15.0345 C55.2545,12.7929 53.42,10.9587 51.1784,10.9587 Z M30.6962,14.7951 C30.5048,14.7951 30.2804,14.646 30.2075,14.4726 L29.2946,11.9097 L29.2796,11.8671 L23.2166,11.8671 C21.0662,11.8671 19.3166,13.6167 19.3166,15.7674 L19.3166,80.2203 C19.3166,82.3707 21.0662,84.1203 23.2166,84.1203 L50.3321,84.1203 C52.4825,84.1203 54.2324,82.3707 54.2324,80.2203 L54.2324,15.7674 C54.2324,13.6167 52.4825,11.8671 50.3321,11.8671 L44.2691,11.8671 L44.2544,11.9097 L43.3427,14.4693 C43.2683,14.646 43.0439,14.7951 42.8525,14.7951 L30.6962,14.7951 L30.6962,14.7951 Z M51.1784,11.0226 C53.3906,11.0226 55.1906,12.8223 55.1906,15.0345 L55.1906,81.1506 C55.1906,83.3628 53.3906,85.1628 51.1784,85.1628 L22.3703,85.1628 C20.1581,85.1628 18.3584,83.3628 18.3584,81.1506 L18.3584,15.0345 C18.3584,12.8223 20.1581,11.0226 22.3703,11.0226 L51.1784,11.0226 L51.1784,11.0226 Z",
    id: "Fill-11",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8006,21.6039 C21.7679,21.7896 21.7478,21.9801 21.7478,22.1754 L21.7478,64.668 C21.7478,66.4773 23.2145,67.944 25.0241,67.944 L49.1492,67.944 C50.9588,67.944 52.4255,66.4773 52.4255,64.668 L52.4255,22.1754 C52.4255,21.9801 52.4054,21.7896 52.3724,21.6039 L21.8006,21.6039",
    id: "Fill-12",
    fill: "#FDFCFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1492,18.8991 L25.0241,18.8991 C23.4098,18.8991 22.0715,20.0673 21.8006,21.6039 L52.3724,21.6039 C52.1018,20.0673 50.7635,18.8991 49.1492,18.8991",
    id: "Fill-13",
    fill: "#466EA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2768,61.5051 L28.8965,61.5051 C27.755,61.5051 26.8298,60.5799 26.8298,59.4384 C26.8298,58.2969 27.755,57.3717 28.8965,57.3717 L45.2768,57.3717 C46.4183,57.3717 47.3435,58.2969 47.3435,59.4384 C47.3435,60.5799 46.4183,61.5051 45.2768,61.5051",
    id: "Fill-14",
    fill: "#466EA5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-15",
    fill: "#9B9B9B",
    points: "27.101 49.3854 46.5809 49.3854 46.5809 49.1805 27.101 49.1805"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-16",
    fill: "#9B9B9B",
    points: "27.101 51.1563 46.5809 51.1563 46.5809 50.9514 27.101 50.9514"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-17",
    fill: "#9B9B9B",
    points: "29.5823 52.8828 44.591 52.8828 44.591 52.6779 29.5823 52.6779"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1166,60.8325 C65.8961,60.8325 65.7176,60.654 65.7176,60.4335 L65.7176,56.9982 C65.7176,54.4182 63.6185,52.3191 61.0385,52.3191 C58.4582,52.3191 56.3594,54.4182 56.3594,56.9982 L56.3594,60.4335 C56.3594,60.654 56.1809,60.8325 55.9604,60.8325 C55.7402,60.8325 55.5614,60.654 55.5614,60.4335 L55.5614,56.9982 C55.5614,53.9781 58.0184,51.5211 61.0385,51.5211 C64.0586,51.5211 66.5159,53.9781 66.5159,56.9982 L66.5159,60.4335 C66.5159,60.654 66.3371,60.8325 66.1166,60.8325",
    id: "Fill-40",
    fill: "#0C2186"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-41",
    fill: "#466EA5",
    points: "67.3832 58.8159 48.401 58.8159 46.5809 85.3287 65.5634 85.3287 67.3832 58.8159"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-42",
    fill: "#2E5FA3",
    points: "70.6235 58.8159 67.3832 58.8159 65.5634 85.3287 72.7721 85.3287 70.6235 58.8159"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-43",
    fill: "#274E84",
    points: "65.5634 85.3287 69.1736 83.0136 72.7721 85.3287 65.5634 85.3287"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-44",
    fill: "#274E84",
    points: "69.1736 83.0136 69.1736 58.8159 70.6235 58.8159 72.7721 85.3287 69.1736 83.0136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4893,60.8325 C62.2688,60.8325 62.0903,60.654 62.0903,60.4335 L62.0903,56.9982 C62.0903,54.4182 59.9912,52.3191 57.4109,52.3191 C54.8309,52.3191 52.7318,54.4182 52.7318,56.9982 L52.7318,60.4335 C52.7318,60.654 52.5533,60.8325 52.3328,60.8325 C52.1126,60.8325 51.9338,60.654 51.9338,60.4335 L51.9338,56.9982 C51.9338,53.9781 54.3911,51.5211 57.4109,51.5211 C60.431,51.5211 62.8883,53.9781 62.8883,56.9982 L62.8883,60.4335 C62.8883,60.654 62.7095,60.8325 62.4893,60.8325",
    id: "Fill-45",
    fill: "#466EA5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#466EA5",
    cx: 37.1,
    cy: 34.5,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-17",
    fill: "#507CB9",
    cx: 56.9,
    cy: 70.2,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#B2B2B2",
    cx: 75.35,
    cy: 26.25,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-14",
    fill: "#B2B2B2",
    cx: 65.1,
    cy: 40.6,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-4",
    fill: "#B2B2B2",
    cx: 2,
    cy: 33,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-11",
    fill: "#B2B2B2",
    cx: 14.15,
    cy: 52.35,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-12",
    fill: "#B2B2B2",
    cx: 55.85,
    cy: 0.75,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-13",
    fill: "#B2B2B2",
    cx: 10.55,
    cy: 3.75,
    r: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyPointsIcon);
export default __webpack_public_path__ + "static/media/my_points_icon.a9e212a098f3e1beb4259edd9be1c1be.svg";
export { ForwardRef as ReactComponent };